<template>

  <div class="home">
    <Navbar :is-active="4"></Navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>Menu QuickPay</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/ClientesB2C" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-shopping-bag"></i>
            </div>
            <div class="tab__text">
              <p>Clientes B2C</p>
            </div>
          </router-link>
          <router-link to="/ClientesB2B" class="tab ">
            <div class="tab__icon">
              <i class="fas fa-globe"></i>
            </div>
            <div class="tab__text">
              <p>Clientes B2B</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Cliente B2C </h2>
        </div>
        <div class="page__subtitle">
          <h3>Información </h3>
        </div>
        <section class="page__filters">
          <div class="input" style="background: #e7e7e7;">
            <p>Fecha de cracion</p>
            <span>{{ dateFormat(created_at) }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Numero de documento</p>
            <span>{{ company_ruc }}</span>
          </div>
          <div class="input">
            <p>Celular</p>
            <input type="text" v-model="company_contact_cellphone">
          </div>
          <div class="input" >
            <p>Email </p>
            <input type="text" v-model="company_contact_email">
          </div>
          <div class="input" >
            <p>Nombre</p>
            <input type="text" v-model="company_contact_name">
          </div>
          <div class="input" >
            <p>Apellido </p>
            <input type="text" v-model="company_contact_lastname">
          </div>
        </section>
         
          <div class="page__table" v-if="tag===0">
            <div class="page__title">
              <div class="page__title">
                <h2 @click="changePageView(0)" class="active_tab"> Medios de pago </h2>
                <h2 @click="changePageView(1)" class="default_tabs"> Productos </h2>
                <h2 @click="changePageView(2)" class="default_tabs"> Boletas </h2>
              </div>
            </div>
            <div class="page__table">
              <div class="table-headers">
                <p>ID</p>
                <p>Fecha de registro</p>
                <p>Metodo de pago</p>
                <p>Tipo de metodo de pago</p>
                <p>Nro de tarjeta</p>
                <p>Tipo CVV</p>
                <p>Estado</p>
              </div>
              <div class="table-body">
                <div class="data" v-for="branch of B2C.card.data" v-bind:key="branch.id">
                  <p>{{ branch.id }}</p>
                  <p>{{ branch.created_at }}</p>
                  <p>TD</p>
                  <p>{{ branch.card_tipo }}</p>
                  <p>{{ branch.card_number }}</p>
                  <p>Dinamico</p>
                  <p>Activo</p>
                </div>
              </div>
            </div>
          </div>
          <div class="page__table" v-if="tag===1">
            <div class="page__title">
              <div class="page__title">
                <h2 @click="changePageView(0)" class="default_tabs"> Medios de pago </h2>
                <h2 @click="changePageView(1)" class="active_tab"> Productos </h2>
                <h2 @click="changePageView(2)" class="default_tabs"> Boletas </h2>
              </div>
            </div>
            <div class="page__table">
              <div class="table-headers">
                <p>Código del producto</p>
                <p>Nombre del producto</p>
                <p>Descripcion</p>
                <p>Precio</p>
                <p>Descuento</p>
                <p>Tipo</p>
                <p>Marca</p>
              </div>
              <div class="table-body">
                <div class="data" v-for="branch of B2C.product.data" v-bind:key="branch.id">
                  <p>{{ branch.product_code }}</p>
                  <p>{{ branch.product_name }}</p>
                  <p>{{ branch.product_descripcion }}</p>
                  <p>{{ branch.product_price }}</p>
                  <p>{{ branch.product_discout }}</p>
                  <p>{{ branch.type }}</p>
                  <p>{{ branch.brand }}</p>
                </div>
              </div>
            </div>
          </div>
            <div class="page__table" v-if="tag===2">
              <div class="page__title">
                <div class="page__title">
                  <h2 @click="changePageView(0)" class="default_tabs"> Medios de pago </h2>
                  <h2 @click="changePageView(1)" class="default_tabs"> Productos </h2>
                  <h2 @click="changePageView(2)" class="active_tab"> Boletas </h2>
                </div>
              </div>
            <div class="page__table">
              <div class="table-headers">
                <p>Código de boleta</p>
                <p>Titulo de boleta</p>
                <p>Estado</p>
                <p>Precio</p>
                <p>Cantidad</p>
                <p>Nombre</p>
                <p>Apellido</p>
              </div>
              <div class="table-body">
                <div class="data" v-for="branch of B2C.invoice.data" v-bind:key="branch.id">
                  <p>{{ branch.id }}</p>
                  <p>{{ branch.Titulo }}</p>
                  <p>{{ branch.estado }}</p>
                  <p>{{ branch.invoice_price }}</p>
                  <p>{{ branch.invoice_amount }}</p>
                  <p>{{ branch.nombre }}</p>
                  <p>{{ branch.apellido }}</p>
                </div>
              </div>
            </div>
          </div>

       <section class="page__actions">
         <button>
           <span>Cancelar</span>
           <i class="fa fa-times-circle"></i>
         </button>
         <button @click="saveClient">
           <span>Guardar</span>
           <i class="fa fa-circle-check"></i>
         </button>
       </section>
      </div>

    </div>
  </div>

</template>

<script>
// @ is an alias to /src
import axios from "axios";
import OpenArrow from '@/components/OpenArrow.vue'
import HiddenArrow from '@/components/HiddenArrow.vue'
import { codeFormat } from '@/utils/formats'
import { dateFormat } from '@/utils/formats'
import Navbar from '@/components/NavBar'

export default {
  name: 'AdminAddUserB2C',
  components: {
    OpenArrow,
    HiddenArrow,
    Navbar
  },
  data(){
    return{
      tag: 0,
      branchoffice: '',
      company_name:'',
      company_ruc:'',
      created_at:'',
      company_contact_cellphone:'',
      company_contact_email:'',
      company_contact_lastname:'',
      company_contact_name:'',
      B2C: null,
      fecha: '',
      usuario: '',
    }
  },
  created() {
    const valores = window.location.search;
    const urlParams = new URLSearchParams(valores);
    const id = urlParams.get('id');
    this.getall(id);
    this.getallb2c(id)
    this.usuario = localStorage.getItem('usuario');
    this.getDate();
  },
  methods:{
    codeFormat,
    dateFormat,
    getDate() {
      let dias = [
        'Lunes',
        'Martes',
        'Miercoles',
        'Jueves',
        'Viernes',
        'Sabado',
        'Domingo'
      ]
      let meses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ]

      let date = new Date()

      var fechaNum = date.getDate()
      var mes_name = date.getMonth()

      this.fecha =
          dias[date.getDay() - 1] +
          ' ' +
          this.zeroFill(fechaNum, 2) +
          ' de ' +
          meses[mes_name]
    },
    zeroFill(number, width) {
      width -= number.toString().length
      if (width > 0) {
        return (
            new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
        )
      }
      return number + ''
    },
    url(path) {
      this.$router.push(path)
    },
    changePageView(valor){
      this.tag=valor
    },
    async getallb2c(id){
      const { data } = await axios.get('general/b2c/client-by-id/'+id);
      this.B2C = data.data
      this.company_contact_cellphone = data.data.cellphone;
      this.created_at = data.data.created_at;
      this.company_contact_email = data.data.email;
      this.company_contact_name = data.data.user_name;
      this.company_contact_lastname = data.data.user_lastname;
      this.company_ruc = data.data.user_doc_number;

    },
    async getall(id){
      const { data } = await axios.get('general/company/'+id);
      this.branchoffice = data.data;
    },
    changePage(url) {
      this.$router.push(url)
    },
    handleClick(){
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    backCompany(){
      this.$router.push('/comercial')
    },
    async saveClient(){
      try {
        const json = {
          "email": this.company_contact_email,
          "user_name": this.company_contact_name ,
          "user_lastname": this.company_contact_lastname ,
          "cellphone": this.company_contact_cellphone ,
        }
        const valores = window.location.search;
        const urlParams = new URLSearchParams(valores);
        const id = urlParams.get('id');

        const response = await axios.put('general/b2c/update/'+id, json)


        if(response.status === 200){
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Editado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
          this.$router.push('/ClientesB2C')
        }
      } catch (error) {
        console.log(error)
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      }
    }
  }
}


</script>

<style scoped>

.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}


/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
  width: 20%;
}
.home .navbar__right .profile {
  display: flex;
  width: 100%;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
a:hover {
  text-decoration: none;
}
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;
}
.body__sidebar,
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 50px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}
/*----------------------------*/
/*----------------------------*/
/*----------------------------*/
.body__containt {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  overflow-y: scroll;
}
.body__containt .page__subtitle,
.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #000;
  font-size: 25px;
}
.body__containt .page__title h2 span {
  color: #ff3128;
}
.body__containt .page__subtitle h3  {
  color: #ff3128;
  font-weight: 600;
  font-size: 20px;
}

.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}

.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
/*-----FILTERS------*/

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 40px;
}

.body__containt .page__filters .input {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #938f8f;
  display: flex;
  flex-direction: column;
  padding: 7px 15px;
  transition: 0.4s ease;

}

.body__containt .page__filters .input:hover {
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.05);
}


.body__containt .page__filters .input span {
  font-size: 15px;
  color: #938f8f;
}
.body__containt .page__filters .input p {
  margin: 0;
}

.page__filters input, select{
  outline:none;
  border: none;
  background: white;
}

/*-----PRODUCT------*/
.page__product {
  width: 100%;
  display: flex;
  padding-bottom: 50px;
  border-bottom: 1px solid #938f8f;
}

.page__product .product__image,
.page__product .product__buttons {
  /* width: 50%; */
  display: flex;
  align-items: center;
}
.page__product .product__image {
  width: 400px;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.page__product .product__image img {
  width: 100%;
  object-fit: cover;
  transition: 1s ease;
}
.page__product .product__image img:hover {
  transform: scale(1.1) rotate(1deg);
}
.page__product .product__buttons {
  width: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.page__actions button,
.page__product .product__buttons button {
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.page__actions button:hover,
.page__product .product__buttons button:hover {
  transform: scale(1.1);
}
.page__actions button:nth-child(2),
.page__product .product__buttons button:nth-child(1) {
  background: #32ba7c;
}
.page__product .product__buttons button:nth-child(2) {
  background: #262626;
}
.page__product .product__buttons button:hover:nth-child(2) {
  background: #ff3128;
}

/*------------------------*/
/*------------------------*/
/*------------------------*/

.page__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px 0;
  gap: 20px;
}

.page__actions button:nth-child(1) {
  background: #ff3128;
}
.page__tabs{
  width: 25%;
  display: flex;
  justify-content: flex-start;
  justify-content: space-between;
}
.page__tabs button{
  border: none;
  background-color: white;
}
.page__tabs button{
}
.page__tabs button h5:hover{
  color: #ff3128;
  
}
.page__tabs button:focus{
  outline: none;
}
.page__tabs .active{
  width: 170px;
  height: 100px;
  border-bottom: 1px solid;
  margin-bottom: -1px;
  color: #ff3128;
  transition: .3s ease;
}

/*------BODY------*/

  .body__sidebar.open{
    display: none;
  }
.active_tab{
  color: #ff3128 !important;
  font-weight: 300;

  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;

}
.active_tab::before {
  width: 100px;
  content: '';
  position: absolute;
  top: 50px;
  height: 4px;
  background-color: #ff3128;
}

.default_tabs{
  color: #999999 !important;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}
</style>
